import request from 'sb-request'
import { reducers } from 'redux/core'
import actions from 'redux/actions'
import { modifyItems as modifyQueueItems } from 'redux/models/queue/actions'

import { constants, links } from 'common/helpers'

import unsubscribeInfoQuery from './unsubscribeInfo.graphql'
import unsubscribeFeedbackQuery from './unsubscribeFeedback.graphql'


const fetch = () => (
  request.post('graphql?name=unsubscribeInfo', {
    body: {
      query: unsubscribeInfoQuery,
    },
    modifyResult: ({ queue, unsubscribeReasons }) => {
      const { items: queueItems } = modifyQueueItems(queue)

      return {
        queueItems,
        unsubscribeReasons: unsubscribeReasons || [],
        hasError: !queueItems.length || !unsubscribeReasons.length,
      }
    },
  })
    .then(({ queueItems, unsubscribeReasons, hasError }) => {
      reducers.view.cancelSubscriptionPage.update({ queueItems, unsubscribeReasons, hasError, isFetched: true })
    })
)

const setActiveStep = (activeStep) => {
  reducers.view.cancelSubscriptionPage.update({
    activeStep,
  })
}

const selectReason = ({ activeReason, activeStep }) => {
  reducers.view.cancelSubscriptionPage.update({ activeReason, activeStep })
}

const setRefund = ({ refund, activeStep }) => {
  reducers.view.cancelSubscriptionPage.update({ refund, activeStep })
}

const resubscribe = () =>
  actions.models.subscription.resubscribe({
    popup: constants.analyticsEvents.resubscribePopup.postCancel,
  })
    .then(() => {
      actions.models.router.replace(links.profile.subscriptionStatus)
    })

const setOfferAcceptedForUser = () => {
  // we need this to prevent showing offers more then 1 time (in both cancel flows)
  // use this name because it's used in old flow offer (modals.cancelSubscription.ProlongOffer)
  actions.models.ui.setClosedPopup('prolongOfferModal')
}

const sendFeedback = ({ message, reason, isUnsubscribeSelected }) => {
  actions.models.ui.showRequestLoader()

  return request.post('graphql?name=unsubscribeFeedback', {
    withErrorModal: false,
    body: {
      query: unsubscribeFeedbackQuery,
      variables: {
        input: {
          message,
          reason,
          unsubscribeChoice: isUnsubscribeSelected,
        },
      },
    },
  })
    .finally(() => actions.models.ui.hideRequestLoader())
}


export default {
  fetch,
  setActiveStep,
  selectReason,
  setRefund,
  resubscribe,
  setOfferAcceptedForUser,
  sendFeedback,
}
